"use client"
import React, { useEffect, useState } from 'react';
import { fr }  from 'date-fns/locale/fr';
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useRouter } from 'next/navigation';
import { DateTime } from 'luxon';

type Props = 
{
    selectedDate? : string
    availableDateVentes?: Date[]
}

const Agenda = ({ selectedDate, availableDateVentes }: Props) => 
{

    const router            = useRouter()
    const handleDateChange = (date: Date | null) =>
    {
        if (date) {
            router.push('/biens-en-vente?dateVente=' + DateTime.fromJSDate(date).toISODate())
        }
    }

    
    const availableDate = (availableDateVentes?.map(date => DateTime.fromJSDate(date).toJSDate()) ?? [])
    return (
        <>
            {(availableDateVentes && availableDateVentes.length > 0) && 
            (
                <div className="flex flex-col w-full shadow-lg">
                    <h2 className="text-xl font-bold w-full text-red-600 p-3">
                        Agenda des ventes
                    </h2>
                    <div className='mt-1' id="agendaSideBarContainer">
                        <ReactDatePicker dateFormat="dd/MM/yyyy" 
                            showDisabledMonthNavigation={true} 
                            inline={true} 
                            locale={fr} 
                            includeDates={availableDate} 
                            onChange={handleDateChange} 
                            wrapperClassName="datePicker"
                            selected={selectedDate !== undefined ? DateTime.fromISO(selectedDate, { setZone: true, zone: 'Europe/Paris' }).toJSDate() : null} />
                    </div>
                </div>
            )}
        </>
    )
}

export default Agenda;